import { Outlet } from 'react-router-dom';

import { SettingsNav } from './SettingsNav';

/**
 * Layout route for every settings screen (and /app/billing).
 *
 * The four generated pages each carried their own copy of this frame and its
 * tab list; they now render into the outlet.
 */
export const SettingsLayout = () => (
  <div className="relative mx-auto flex min-h-[calc(100vh-80px)] w-full max-w-[1200px] flex-col gap-8 p-4 md:min-h-screen md:flex-row md:p-8">
    <SettingsNav />
    <div className="relative max-w-3xl flex-1 pb-24">
      <Outlet />
    </div>
  </div>
);
